import { render, staticRenderFns } from "./NotarisEdit.vue?vue&type=template&id=1e5af3b2&"
import script from "./NotarisEdit.vue?vue&type=script&lang=js&"
export * from "./NotarisEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports